import { useState } from 'react';
import { useAuth } from '../context/AuthContext.jsx';
import { Button, Card, Field, Input } from '../components/ui.jsx';

export default function Login() {
  const { login } = useAuth();
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setBusy(true);
    setError(null);

    const form = new FormData(event.currentTarget);

    try {
      await login(form.get('username'), form.get('password'));
      // AuthProvider state change swaps the route; no navigation needed here.
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-acid p-6">
      <Card className="shadow-brutal w-full max-w-md p-10">
        <p className="font-display text-3xl">
          AGEN<span className="text-electric">Z</span>
        </p>
        <p className="mt-1 text-xs font-bold uppercase tracking-widest text-muted">Admin</p>

        <h1 className="mt-8 text-2xl">Sign in</h1>

        <form onSubmit={handleSubmit} className="mt-6 space-y-5">
          <Field label="Username" htmlFor="username" required>
            <Input
              id="username"
              name="username"
              type="text"
              autoComplete="username"
              autoCapitalize="none"
              spellCheck="false"
              required
              autoFocus
            />
          </Field>

          <Field label="Password" htmlFor="password" required>
            <Input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
            />
          </Field>

          {error && (
            <p className="border-3 border-ink bg-blush/30 p-3 text-sm font-semibold" role="alert">
              {error}
            </p>
          )}

          <Button type="submit" size="lg" className="w-full" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>
      </Card>
    </div>
  );
}
